// extracted by mini-css-extract-plugin
export default {"container":"modal_container__xY4gM","content":"modal_content__b6573","title":"modal_title__kWbb+","wrapper":"modal_wrapper__so6Rg"};